import React from "react"
import { FormField, Input } from "semantic-ui-react"
import BifrostModalCreateItem from "../../../../../Components/BifrostPageComponent/BifrostModal/BifrostModalPage/BifrostModalCreateItem"

const ChangeUserLimitPage = ({ validated, values, setValues, showErrorMessage }) => {
	const updateField = (e, name, value) => {
		if (!name) {
			name = e.target.name
			value = e.target.value
		}
		setValues({
			...values,
			[name]: value
		})
	}

	return (
		<BifrostModalCreateItem showErrorMessage={showErrorMessage}>
			<FormField error={!validated.user_limit}>
				<Input type="number" name="user_limit" placeholder="Enter user limit" onChange={(e, { name, value }) => updateField(e, name, Number(value))} />
			</FormField>
		</BifrostModalCreateItem>
	)
}

export default ChangeUserLimitPage
